import React, { FC } from "react";
import cn from "classnames";
import { ISettingsItem } from "./types";
import { useTranslation } from "react-i18next";
import { RenderFormFields } from "src/components/RenderFormFields";

interface Props extends ISettingsItem {}

export const SettingItem: FC<Props> = ({
  title,
  description,
  fieldsContainerClassName,
  containerClassName,
  fields,
}) => {
  const { t } = useTranslation();

  const translatedTitle = t(title.i18nKey, title.i18nParams);
  const translatedDescription =
    description && t(description?.i18nKey, description?.i18nParams);

  return (
    <div className={cn("flex flex-col gap-5 md:gap-10", containerClassName)}>
      <div className="flex flex-col gap-3">
        <h3 className="font-semibold">{translatedTitle}</h3>
        {translatedDescription && <p>{translatedDescription}</p>}
      </div>
      <div className="flex flex-col flex-1 gap-5">
        <div className={cn("flex-1", fieldsContainerClassName)}>
          <RenderFormFields fields={fields} />
        </div>
      </div>
    </div>
  );
};
